module.exports = __webpack_public_path__ + "img/c.bdf6fbd0.png";